import { defaultSounds } from '@pascal/pascal-core/shared/core/services/sound/defaultSounds';
import { SoundService as BaseSoundService, SoundType as BaseSoundTypes } from '@pascal/pascal-core';

defaultSounds.music.loop = true;

const SoundTypes = {
  ...BaseSoundTypes,
  wheel: 'wheel',
};

const options = [
  {
    src: 'wheel.mp3',
    name: SoundTypes.wheel,
    autoplay: false,
    html5: true,
  },
];

class SoundService extends BaseSoundService {
  constructor(props) {
    super(props);
  }
}

const soundService = new SoundService({
  options,
});

export { SoundTypes as soundTypes, soundService };
